import { actions } from 'client/constants';

export const localStorageMiddleware = store => next => action => {
	const returnValue = next(action);
	const { choice } = store.getState();

	const targetActions = [actions.SAVE_USER_CHOICE.SUCCESS];

	if (targetActions.includes(action.type)) {
		localStorage.setItem('c', JSON.stringify({ ...choice }));
	}

	return returnValue;
};
